'use strict';
var React = require('react');
var BaseComponent = require('../../../../../../views/shared/base');
var toastr = require('toastr');

var Numeral = require('numeral');
var Currency = require('currency-symbol-map');

class TransactionSummaryComponent extends BaseComponent {
    
    render() {
        let format = process.env.MONEY_FORMAT;
        const detail = this.props.detail;
        // console.log("Mostrar datos", detail)
        let subTotal = 0;
        let shippingCost = 0;
        let discount = 0; // bulk pricing discount
        let quoteNo = "";
        let quoteID = "";
        let purchaseOrderNo = "";
        let channelRedirect = "#";
        let self = this;
        let chargeTotal = 0;
        let chargeTotalAmount = 0;
        let discountTotal = 0;
        let discountTotalAmount = 0;
        let grandTotal = 0;
        let haveQuote = false;0
        let checkoutFlowType = this.props.checkoutFlowType;
        let notesToSeller = '';
        let subTotalAmount = 0;
        let arrCartItems = [];
        let finalShipping = 0;
        let semitotal = 0;
        let envioB2C = 0;
        let newIva = 0;
        detail.Orders.forEach(function (order) {
            subTotalAmount += order.Total;
            shippingCost += order.Freight;
            newIva += order.Tax;
            let orderTotal = parseFloat(order.Total);
            let orderTax = parseFloat(order.Tax);
            semitotal = orderTotal + orderTax;
            // console.log("semitotal", semitotal);
            if (order.PurchaseOrderNo) {
                //ARC10131
                purchaseOrderNo = order.CosmeticNo != null && order.CosmeticNo != "" ? order.CosmeticNo : order.PurchaseOrderNo;
            }

            // quotation or bulk pricing discount;
            discountTotalAmount += order.DiscountAmount || 0;

            // quotation charge
            chargeTotalAmount += order.Surcharge || 0;

            if (order.CartItemDetails) {
                order.CartItemDetails.forEach(function (cartItemDetail) {
                    if (cartItemDetail.DiscountAmount) {
                        discount += cartItemDetail.DiscountAmount === null ? 0 : cartItemDetail.DiscountAmount;
                    }
                    if (cartItemDetail.AcceptedOffer) {
                        channelRedirect = "/chat?channelId=" + cartItemDetail.AcceptedOffer.ChannelID;
                        quoteNo = cartItemDetail.AcceptedOffer.CosmeticNo != null && cartItemDetail.AcceptedOffer.CosmeticNo != "" ? cartItemDetail.AcceptedOffer.CosmeticNo : cartItemDetail.AcceptedOffer.QuoteNo;
                        quoteID = cartItemDetail.AcceptedOffer.ID;
                    }
                    if (cartItemDetail.Notes) {
                        notesToSeller = cartItemDetail.Notes;
                        // console.log(notesToSeller);
                        let hasEnvioB2C = notesToSeller.includes('PrecioEnvioB2C');
                        // console.log(hasEnvioB2C);
                        if(hasEnvioB2C){
                            let notesArray = notesToSeller.split('|');
                            let priceString = notesArray.find(a =>a.includes("PrecioEnvioB2C"));
                            let priceAlone = priceString.replace('PrecioEnvioB2C:','');
                            envioB2C = parseFloat(priceAlone);
                        }

                        // console.log(
                        //     `The word "${'PrecioEnvioB2C'}" ${
                        //         notesToSeller.includes('PrecioEnvioB2C') ? 'is' : 'is not'
                        //     } in the sentence`,
                        // );
                    }

                    //Convert amount to USD if apply
                    subTotal = self.UseCurrency( subTotalAmount - discount, detail.CurrencyCode, cartItemDetail.CustomFields);
                    chargeTotal = self.UseCurrency( chargeTotalAmount, detail.CurrencyCode, cartItemDetail.CustomFields);
                    discountTotal = self.UseCurrency( discountTotalAmount, detail.CurrencyCode, cartItemDetail.CustomFields);
                    arrCartItems.push(<span className="item-price">{self.strResolveItemFullName(cartItemDetail)}</span>);
                });
            }
        });

        grandTotal = (subTotal + shippingCost + chargeTotal) - discountTotal;

        finalShipping = Math.round(this.props.detail.Total - semitotal);
        // console.log("finalShipping", finalShipping);
        let iva = (subTotal + shippingCost) * 0.16;
        let subtotalP = subTotal + shippingCost;
        grandTotal = subtotalP + iva;

        var price16 = (subTotal + shippingCost) * 0.16;
        var price8 = (subTotal + shippingCost) * 0.08;
        var dif1 = price16 - newIva;
        var dif2 = price8 - newIva;
        var ivaText = '16%';
        if(dif1 < 5) {
            ivaText = '16%';
        } else if(dif2 < 5) {
            ivaText = '8%';
        }


        // remove the bulk pricing discount since it should only contains quotation discount for display
        discountTotal -= discount;

        return (
           
                    <div className="row">
                        {/*<div className="col-md-4">
                            {
                                this.props.showNotes == true?
                                    <React.Fragment>
                                        <h4> Notes to seller </h4>
                                        <p>{notesToSeller}</p>
                                    </React.Fragment>
                                : ''
                            }
                            {
                                quoteNo !== "" && channelRedirect !== "#" ?
                                    <p><a href={channelRedirect} className="sassy-black-btn">Show Chat Log</a></p>
                                : ''
                            }
                        </div>*/}
                        {/*<div className="col-md-4">
                            <table className="canon-table">
                                <tbody>
                                    {
                                        quoteNo !== "" ?
                                            <tr>
                                                <th>Quote No. :</th>
                                                <td data-th="Requisition Order No. :"><a href={"/quotation/detail?id=" + quoteID}><span className="highlight-text">{quoteNo}</span></a></td>
                                            </tr> : ""
                                    }
                                </tbody>
                            </table>
                        </div>*/}
                        
                        <div className="col-md-4">
                            <label className="OD-tittle-subsection">Resumen de pedido</label>
                            <table className="cost-table" id="resumen-pedido">
                                <tbody>
                                    <tr>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td>Productos</td>
                                        <td>
                                            {/*Just added in order to do not left blank spaces for this table*/}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div style={{display:'grid'}}>
                                                {arrCartItems}
                                            </div>
                                        </td>
                                        <td>
                                            {/*Just added in order to do not left blank spaces for this table*/}
                                        </td>
                                    </tr>
                                   { /*<tr>
                                        <td>Carga(s)</td>
                                        {
                                            chargeTotal === 0 ? <td><span className="item-price">-</span></td>
                                                : <td><span className="item-price"> {self.renderFormatMoney(detail.CurrencyCode, chargeTotal)}</span></td>
                                        }
                                      
                                    </tr>
                                    <tr>
                                        <td>Descuento(s)</td>
                                        {
                                            discountTotal === 0 ? <td><span className="item-price">-</span></td>
                                                :
                                                <td>
                                                    <span>-</span>
                                                    <span className="item-price"> {self.renderFormatMoney(detail.CurrencyCode, discountTotal)}</span>
                                                </td>
                                        }                                        
                                    </tr>*/}
                                    <tr>
                                        <td>Envío</td>
                                        {
                                            envioB2C === 0 ? <td><span className="item-price">-</span></td>
                                                :
                                                <td>
                                                    <span className="item-price">
                                                        <span className="currencySymbol"> {Currency(detail.CurrencyCode)}</span>
                                                        <span className="priceAmount"> {Numeral(envioB2C).format(format)}</span>
                                                    </span>
                                                </td>
                                        }
                                                {/*<td>
                                                    <span className="item-price"> {self.renderFormatMoney(detail.CurrencyCode, shippingCost)}</span>
                                                </td>*/}

                                                
                                            
                                    </tr>
                                    {/* <tr>
                                        <td>Envío IVA(16%)</td>
                                        {
                                            envioB2C === 0 ? <td><span className="item-price">-</span></td>
                                                :
                                                <td>
                                                    <span className="item-price">
                                                        <span className="currencySymbol"> {Currency(detail.CurrencyCode)}</span>
                                                        <span className="priceAmount"> {Numeral(envioB2C*0.16).format(format)}</span>
                                                    </span>
                                                </td>
                                        }
                                    </tr> */}
                                    <tr>
                                        <td>Subtotal</td>
                                        {
                                            subtotalP === 0 ? <td><span className="item-price">-</span></td>
                                                :
                                                <td>
                                                    <span className="item-price">
                                                        <span className="currencySymbol"> {Currency(detail.CurrencyCode)}</span>
                                                        <span className="priceAmount"> {Numeral(subtotalP).format(format)}</span>
                                                        <span className="currencySymbol"> {detail.CurrencyCode}</span>
                                                    </span>
                                                </td>
                                        }  
                                        {/*
                                            <td>
                                                    <span className="item-price"> {self.renderFormatMoney(detail.CurrencyCode, subtotalP)}</span>
                                                </td>
                                        */}      
                                    </tr>
                                    {<tr>
                                            <td>IVA({ivaText})</td>
                                            <td>
                                                <span className="item-price">
                                                    <span className="currencySymbol"> {Currency(detail.CurrencyCode)}</span>
                                                    <span className="priceAmount"> {Numeral(newIva).format(format)}</span>
                                                    <span className="currencySymbol"> {detail.CurrencyCode}</span>
                                                </span>
                                            </td>
                                        </tr> }
                                </tbody>
                                <tfoot>
                                    <tr id="div-summary-order" className="divider">
                                        <td colSpan={2} />
                                    </tr>
                                    <tr>
                                        <td>
                                            Total incluye IVA: 
                                        </td>
                                        <td>
                                            <span className="item-price">
                                                <span className="currencySymbol"> {Currency(detail.CurrencyCode)}</span>
                                                <span className="priceAmount"> {Numeral(detail.Total).format(format)}</span>
                                                <span className="currencySymbol"> {detail.CurrencyCode}</span>
                                            </span>
                                        </td>
                                        
                                        {/*<td><span className="item-price"> {self.renderFormatMoney(detail.CurrencyCode, grandTotal)}</span></td>*/}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className="col-md-12">
                            <div className="spacer-20"></div>
                            
                        </div>
                    </div>
                
        );
    }

    UseCurrency( 
        numTotal_I, 
        InvoiceCurrencyCode_I,
        InvoiceCF_I
        )
    {
        let numTotalWithCurrency = numTotal_I;
        if(InvoiceCurrencyCode_I == "USD" && InvoiceCF_I != null){
            //Resolve exchange rate used at checkout
            let currencyCF = InvoiceCF_I.find(cf => cf.Name == "ExchangeRate");
            if(currencyCF != null){
                numTotalWithCurrency = numTotalWithCurrency / parseFloat(currencyCF.Values[0]);
            }
        }

        return numTotalWithCurrency;
    }

    strResolveItemFullName(
        cartItemDetail
    )
    {
        let strItemFullName = "";
        if (
            cartItemDetail.CustomFields != undefined
            )
        {
            let cf = cartItemDetail.CustomFields.find(cf => cf.Name == "PartCode");
            if (
                cf != undefined
                )
            {
                strItemFullName = cf.Values[0] + " - ";
            }
        }
        strItemFullName += cartItemDetail.ItemDetail.Name;
        
        return strItemFullName;
    }
}

module.exports = TransactionSummaryComponent;